export const CartCommentLabels = {
  Merchant: `comment-modal.comment-for-the-shop`,
  Delivery: 'comment-modal.comment-for-the-deliverer',
};
